import { _ } from "../../core/polyglot/polyglot.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import BusinessTrendComparisonPicker from "./BusinessTrendComparisonPicker/BusinessTrendComparisonPicker.js";

/**
 * This widget is responsible for displaying the action bar of
 * `businessTrendDocument`.
 *
 * It consists of a dropdown and an explanation message. The dropdown
 * selection is used as a comparison against the current year data.
 *
 * @param {function} onChange - Called with the selection as argument
 * when the user changes the selection in the dropdown.
 */
export default class BusinessTrendActionsWidget extends Widget {
	constructor({ onChange }) {
		super(...arguments);

		this._comparisonPeriodPicker = new BusinessTrendComparisonPicker({
			onChange,
		});
	}

	setComparisonElements(...rest) {
		this._comparisonPeriodPicker.setElements(...rest);
	}

	getComparedElement() {
		return this._comparisonPeriodPicker.getElement();
	}

	setCurrentFiscalYear(currentYear) {
		return this._comparisonPeriodPicker.setCurrentFiscalYear(currentYear);
	}

	renderContentOn(html) {
		html.div(this._renderComparisonPickerOn.bind(this));
	}

	_renderComparisonPickerOn(html) {
		html.render(
			this._sectionRenderer({
				label: _("Compare to"),
				dataHelpName: "compare-to",
				content: this._comparisonPeriodPicker,
			}),
		);
	}

	_sectionRenderer({ label, content, dataHelpName }) {
		return (html) =>
			html.div(
				{ klass: "right-menu-section", "data-help": dataHelpName },
				(html) => {
					if (label) {
						html.label(label);
					}
					html.render(content);
				},
			);
	}
}
